import React from "react";

interface QuizNotFoundDialogProps {
  show: boolean;
  onNavigateHome: () => void;
}

export const QuizNotFoundDialog: React.FC<QuizNotFoundDialogProps> = ({
  show,
  onNavigateHome,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-bold mb-4">Quiz Not Found</h3>
        <button
          className="bg-primary text-white py-2 px-4 rounded hover:bg-primary/80"
          onClick={onNavigateHome}
        >
          Home
        </button>
      </div>
    </div>
  );
};
